import React from 'react';
import { StyledBillingTableErrorRow } from './StyledComponents';

const BillingTableErrorRow = () => <StyledBillingTableErrorRow>!</StyledBillingTableErrorRow>;

export default BillingTableErrorRow;
